import{createContext as r,useContext as t}from"react";var a=r(),e=function(){return t(a)};export{a as PermissionsContext,e as default};
